import { Card, TableDataRequest } from '@fl/cmsch-fe-library';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Opt } from 'ts-opt';
import { CorrectionReport } from 'api/gen/CorrectionReport';
import { Content } from 'app/content';
import * as routerActions from 'app/router';
import { useOurTranslation } from 'app/translations';
import { ConnectedScreenHeader } from 'common/layout';
import { OverviewTable } from '../components';
import { analysisProtocolCorrectionAction } from '../model';
const OverviewBase: FC = () => {
  const {
    t
  } = useOurTranslation('analysisProtocolCorrection');
  const dispatch = useDispatch();
  const getCorrectionReports = useCallback((tableDataRequest: Opt<TableDataRequest<CorrectionReport>>) => {
    dispatch(analysisProtocolCorrectionAction.getCorrectionReports(tableDataRequest));
  }, [dispatch]);
  const deleteCorrectionReport = useCallback((id: number) => {
    dispatch(analysisProtocolCorrectionAction.deleteCorrectionReport(id, false));
  }, [dispatch]);
  const exportCorrectionReports = useCallback(() => {
    dispatch(analysisProtocolCorrectionAction.exportCorrectionReports());
  }, [dispatch]);
  const goToNewReport = useCallback(() => {
    dispatch(routerActions.push('/analysis-protocol-correction/new'));
  }, [dispatch]);
  const editCorrectionReport = useCallback((report: CorrectionReport) => {
    dispatch(routerActions.push(`/analysis-protocol-correction/${report.id}`));
  }, [dispatch]);
  const header = useMemo(() => <ConnectedScreenHeader title={t('analysisProtocolCorrectionReportOverview')} moduleForTutorials="APC" />, [t]);
  return <Content browserTabTitle={t('analysisProtocolCorrectionReportOverview')} data-sentry-element="Content" data-sentry-component="OverviewBase" data-sentry-source-file="overview.tsx">
            <Card title={header} titleSize="medium" noWhiteSpaceBody data-sentry-element="Card" data-sentry-source-file="overview.tsx">
                <OverviewTable getCorrectionReports={getCorrectionReports} deleteCorrectionReport={deleteCorrectionReport} exportCorrectionReports={exportCorrectionReports} editCorrectionReport={editCorrectionReport} goToNewReport={goToNewReport} data-sentry-element="OverviewTable" data-sentry-source-file="overview.tsx" />
            </Card>
        </Content>;
};

/**
 * Renders the analysis protocol correction overview screen.
 */
export const Overview = memo(OverviewBase);